// extracted by mini-css-extract-plugin
module.exports = {"candidateLinkItem":"candidateLinkItem_candidateLinkItem__7S0et","candidateLinkItem__icon":"candidateLinkItem_candidateLinkItem__icon__3mzCT"};